const TIPOS_EXAME = [
  { value: 1, text: 'Admissional', slug: 'admissional' },
  { value: 2, text: 'Demissional', slug: 'demissional' },
  { value: 3, text: 'Periódico', slug: 'periodico' },
  { value: 4, text: 'Mudança de Risco Ocupacional', slug: 'mudanca-de-risco-ocupacional' },
  { value: 5, text: 'Retorno ao Trabalho', slug: 'retorno-ao-trabalho' },
  { value: 6, text: 'Monitoração Pontual', slug: 'monitoracao-pontual' },
  { value: 7, text: 'Consulta', slug: 'consulta' },
]

const CLINICA_FORMA_PAGAMENTO = [
  { value: 'avulso', text: 'Avulsa' },
  { value: 'mensal', text: 'Mensal' },
  { value: 'externa', text: 'Externa' },
]

const TIPO_FATURAMENTO_CLINICA = [
  { value: 'nao_faturada', text: 'Não faturada' },
  { value: 'faturada_pre', text: 'Faturada pré' },
  { value: 'faturada_pos', text: 'Faturada pós' },
]

const MODALIDADE = [
  { value: 'presencial', text: 'Presencial' },
  { value: 'online', text: 'Online' },
]

const STATUS_CLINICA = [
  { text: 'Todas', value: null },
  { text: 'Ativa', value: 'ativo' },
  { text: 'Em análise', value: 'analise' },
  { text: 'Inativa', value: 'inativo' },
  { text: 'Em recesso', value: 'recesso' },
]

const STATUS_CONTRATO = [
  { text: 'Vencido', value: 'vencido' },
  { text: 'A Vencer', value: 'vencer' },
]

const STATUS_ASO = [
  { value: 1, text: 'Agendado', color: 'primary' },
  { value: 2, text: 'Em Análise', color: 'primary' },
  { value: 3, text: 'Finalizado', color: 'success' },
  { value: 4, text: 'Inativo', color: 'bluegreylight' },
  { value: 5, text: 'Não Compareceu', color: 'info' },
  { value: 6, text: 'Aguardando', color: 'warning' },
  { value: 7, text: 'Atrasado', color: 'error' },
  { value: 8, text: 'Em aberto', color: 'purple' },
  { value: 9, text: 'Incompleto', color: 'greydarken' },
  { value: 10, text: 'Aguardando Complementares', color: 'deep-purple' },
  { value: 11, text: 'Aguardando Finalização', color: '#004D40' },
  { value: 12, text: 'Aguardando Clínico', color: 'teal' },
]

const STATUS_CREDENCIAMENTO_CLINICA = [
  { value: 'cadastrado', text: 'Cadastrado', color: 'success' },
  { value: 'onboarding_pendente', text: 'Onboarding Pendente', color: 'warning' },
  { value: 'nao_credenciado', text: 'Não Credenciado', color: 'grey' },
  { value: 'credenciamento_recusado', text: 'Credenciamento Recusado', color: 'error' },
]

const STATUS_DOCUMENTO = [
  { value: 'valido', text: 'Válido' },
  { value: 'vencido', text: 'Vencido' },
  { value: 'vencer', text: 'À Vencer' },
  { value: 'naoContratado', text: 'Não Contratado' },
]
const STATUS_DIGITALIZACAO_DOCUMENTOS_FALTANTES = 'documentos_faltantes'

const STATUS_DIGITALIZACAO = [
  { value: 'digitalizacao_em_andamento', text: 'Digitalização em Andamento', color: 'info' },
  { value: 'digitalizacao_concluida', text: 'Digitalização Concluída', color: 'success' },
  { value: STATUS_DIGITALIZACAO_DOCUMENTOS_FALTANTES, text: 'Documentos Faltantes', color: 'warning' },
]

const ABA_GED = {
  FINALIZADOS: 'finalizados',
  COM_PENDENCIA: 'com_pendencia',
  EM_DIGITALIZACAO: 'em_digitalizacao',
}

const ABAS_GED = [
  { value: ABA_GED.FINALIZADOS, text: 'Finalizados' },
  { value: ABA_GED.COM_PENDENCIA, text: 'Com Pendência' },
  { value: ABA_GED.EM_DIGITALIZACAO, text: 'Em digitalização' },
]

const STATUS_DEVOLUCAO_ASO = [
  { value: 'localizado', text: 'Localizado', color: 'info' },
  { value: 'separado', text: 'Separado', color: 'warning' },
  { value: 'devolvido', text: 'Devolvido', color: 'success' },
]

const CATEGORIA_ASO = [
  { value: 'digital', text: 'Digital', color: 'pink' },
  { value: 'hibrido', text: 'Híbrido', color: 'purple' },
  { value: 'fisico', text: 'Físico', color: 'deep-purple' },
]

const STATUS_ART = [
  { value: 'pendente', text: 'Pendente', color: '#FFC107' },
  { value: 'pago', text: 'Pago', color: '#4CAF50' },
  { value: 'inativo', text: 'Inativo', color: '#607D8B' },
  { value: 'validado', text: 'Validado', color: '#4254f5' },
  { value: 'validacao_recusada', text: 'Validação Recusada', color: '#F44336' },
  { value: 'enviado_para_pagamento', text: 'Enviado para Pagamento', color: '#FF9800' },
  { value: 'em_compensacao', text: 'Em Compensação', color: '#57378a' },
  { value: 'cancelado', text: 'Cancelado', color: '#9e9e9e' },
]

const STATUS_FUNCIONARIO = [
  {
    label: 'Apto',
    color: 'green',
    value: 1,
  },
  {
    label: 'Desligado',
    color: 'red',
    value: 2,
  },
  {
    label: 'Afastado',
    color: 'MediumSlateBlue',
    value: 3,
  },
  {
    label: 'INSS',
    color: 'LightCoral',
    value: 4,
  },
  {
    label: 'A Vencer',
    color: 'Orange',
    value: 5,
  },
  {
    label: 'Vencido',
    color: 'OrangeRed',
    value: 6,
  },
  {
    label: 'Recém Cadastrado',
    color: 'Dim Gray',
    value: 7,
  },
]

const STATUS_CHAMADO = [
  {
    label: 'Apto',
    color: 'green',
    value: 1,
  },
  {
    label: 'Desligado',
    color: 'red',
    value: 2,
  },
  {
    label: 'Afastado',
    color: 'MediumSlateBlue',
    value: 3,
  },
  {
    label: 'INSS',
    color: 'LightCoral',
    value: 4,
  },
  {
    label: 'A Vencer',
    color: 'Orange',
    value: 5,
  },
  {
    label: 'Vencido',
    color: 'OrangeRed',
    value: 6,
  },
  {
    label: 'Pendente',
    color: 'Dim Gray',
    value: 7,
  },
]

const dateRegex = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)(19[0-8][0-9]|199[0-9]|20[0-9]{2}|2100)/

const estados = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
]

const MESES = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
]

const oneMegaByteStringSize = 1048576

const TIPOS_ASSINANTES = {
  testemunha: 'Testemunha',
  parte: 'Parte',
  'representante-legal': 'Representante Legal',
}

const unidadesMedida = [
  { text: 'Dose diária de ruído', value: '1' },
  { text: 'Decibel linear (dB (linear))', value: '2' },
  { text: 'Decibel (C) (dB(C))', value: '3' },
  { text: 'Decibel (A) (dB(A))', value: '4' },
  { text: 'Metro por segundo ao quadrado (m/s2)', value: '5' },
  { text: 'Metro por segundo elevado a 1,75 (m/s1,75)', value: '6' },
  { text: 'Parte de vapor ou gás por milhão de partes de ar contaminado (ppm)', value: '7' },
  { text: 'Miligrama por metro cúbico de ar (mg/m3)', value: '8' },
  { text: 'Fibra por centímetro cúbico (f/cm3)', value: '9' },
  { text: 'Grau Celsius (ºC)', value: '10' },
  { text: 'Metro por segundo (m/s)', value: '11' },
  { text: 'Porcentual', value: '12' },
  { text: 'Lux (lx)', value: '13' },
  { text: 'Unidade formadora de colônias por metro cúbico (ufc/m3)', value: '14' },
  { text: 'Dose diária', value: '15' },
  { text: 'Dose mensal', value: '16' },
  { text: 'Dose trimestral', value: '17' },
  { text: 'Dose anual', value: '18' },
  { text: 'Watt por metro quadrado (W/m2)', value: '19' },
  { text: 'Ampère por metro (A/m)', value: '20' },
  { text: 'Militesla (mT)', value: '21' },
  { text: 'Microtesla (μT)', value: '22' },
  { text: 'Miliampère (mA)', value: '23' },
  { text: 'Quilovolt por metro (kV/m)', value: '24' },
  { text: 'Volt por metro (V/m)', value: '25' },
  { text: 'Joule por metro quadrado (J/m2)', value: '26' },
  { text: 'Milijoule por centímetro quadrado (mJ/cm2)', value: '27' },
  { text: 'Milisievert (mSv)', value: '28' },
  { text: 'Milhão de partículas por decímetro cúbico (mppdc)', value: '29' },
  { text: 'Umidade relativa do ar (UR (%))', value: '30' },
  { text: 'Índice de Bulbo Úmido e Temperatura de Globo (IBUTG)', value: '31' },
]

const SEXOS = [
  { value: 'M', text: 'Masculino' },
  { value: 'F', text: 'Feminino' },
]

const STATUS_PAGAMENTO = [
  { text: 'Pago', value: 'pago' },
  { text: 'Pendente', value: 'pendente' },
]

const STATUS_CUSTO_UNIMED = [
  { text: 'Em Aberto', value: 'em_aberto', color: '#2196F3', icon: 'mdi-circle-outline' },
  { text: 'Fechado', value: 'fechado', color: '#9C27B0', icon: 'mdi-check-circle' },
  { text: 'Pago', value: 'pago', color: '#4CAF50', icon: 'mdi-check-circle' },
  { text: 'Cancelado', value: 'cancelado', color: '#B00020', icon: 'mdi-close-circle' },
  { text: 'Vencido', value: 'vencido', color: '#B00020', icon: 'mdi-close-circle' },
]

const STATUS_INVOICE_CUSTO_UNIMED = [
  { value: 'SCHEDULED', text: 'Agendada', color: '#e65100' },
  { value: 'AUTHORIZED', text: 'Autorizada', color: '#2e7d32' },
  { value: 'INVOICE_AUTHORIZED', text: 'Autorizada', color: '#2e7d32' },
  { value: 'AUTORIZADA', text: 'Autorizada', color: '#2e7d32' },
  { value: 'PROCESSING_CANCELLATION', text: 'Cancelamento em processamento', color: '#e65100' },
  { value: 'CANCELED', text: 'Cancelada', color: '#757575' },
  { value: 'CANCELLED', text: 'Cancelada', color: '#757575' },
  { value: 'CANCELLATION_DENIED', text: 'Cancelamento negado', color: '#e65100' },
  { value: 'ERROR', text: 'Erro', color: '#e65100' },
]

/** Quando `invoice_status` vem vazio: inferir só por PDF/número da nota. */
const STATUS_INVOICE_CUSTO_UNIMED_FALLBACK = {
  com_documento: { text: 'Autorizada', color: '#2e7d32' },
  sem_documento: { text: 'Pendente', color: '#e65100' },
}

const STATUS_INVOICE_CUSTO_UNIMED_DESCONHECIDO_COLOR = '#757575'

const DIAS_SEMANA = [
  { index: 0, label: 'Domingo', key: 'domingo' },
  { index: 1, label: 'Segunda-feira', key: 'segunda' },
  { index: 2, label: 'Terça-feira', key: 'terca' },
  { index: 3, label: 'Quarta-feira', key: 'quarta' },
  { index: 4, label: 'Quinta-feira', key: 'quinta' },
  { index: 5, label: 'Sexta-feira', key: 'sexta' },
  { index: 6, label: 'Sábado', key: 'sabado' },
]
const ORIGEM_PRESTADOR = [
  { value: 'legado', text: 'Legado', color: '#0d274d' },
  { value: 'ucbs', text: 'UCBS', color: '#133366' },
  { value: 'antigo_prestador', text: 'Antigo Prestador', color: '#19588d' },
  { value: 'recorrente', text: 'Recorrente', color: '#214878' },
]

const STATUS_ENVIO_PGR = [
  { value: 'em_andamento', text: 'Em andamento', color: 'orange darken-2' },
  { value: 'em_analise', text: 'Em análise', color: 'blue darken-2' },
  { value: 'finalizado', text: 'Finalizado', color: 'green darken-2' },
  { value: 'erro', text: 'Erro', color: 'red darken-2' },
]

const STATUS_EPI = [
  { value: 'ativo', text: 'Ativo', color: 'success' },
  { value: 'inativo', text: 'Inativo', color: 'grey' },
]

const STATUS_ENTREGA_EPI = [
  { value: 'vigente', text: 'Vigente', color: 'success' },
  { value: 'proximo_vencimento', text: 'Próximo do vencimento', color: 'warning' },
  { value: 'vencido', text: 'Vencido', color: 'error' },
  { value: 'pendente_entrega', text: 'Pendente entrega', color: 'info' },
  { value: 'aguardando_confirmacao', text: 'Aguardando confirmação', color: 'info' },
  { value: 'substituido', text: 'Substituído', color: 'grey' },
  { value: 'cancelada', text: 'Cancelada', color: 'error' },
]

const RISCO_ITEMS = [
  { text: 'Baixo', value: 'baixo', color: 'success' },
  { text: 'Médio Baixo', value: 'medio_baixo', color: 'lime darken-2' },
  { text: 'Médio', value: 'medio', color: 'warning' },
  { text: 'Médio Alto', value: 'medio_alto', color: 'deep-orange' },
  { text: 'Alto', value: 'alto', color: 'error' },
]

const STATUS_ITEMS = [
  { value: 'ativo', text: 'Ativo', color: 'success' },
  { value: 'inativo', text: 'Inativo', color: 'error' },
]

export {
  TIPOS_EXAME,
  MODALIDADE,
  CLINICA_FORMA_PAGAMENTO,
  TIPO_FATURAMENTO_CLINICA,
  STATUS_ASO,
  STATUS_FUNCIONARIO,
  STATUS_CHAMADO,
  SEXOS,
  dateRegex,
  estados,
  oneMegaByteStringSize,
  unidadesMedida,
  TIPOS_ASSINANTES,
  STATUS_CLINICA,
  STATUS_CONTRATO,
  STATUS_CREDENCIAMENTO_CLINICA,
  STATUS_DOCUMENTO,
  STATUS_PAGAMENTO,
  CATEGORIA_ASO,
  STATUS_DIGITALIZACAO,
  STATUS_DIGITALIZACAO_DOCUMENTOS_FALTANTES,
  ABA_GED,
  ABAS_GED,
  STATUS_DEVOLUCAO_ASO,
  STATUS_ART,
  STATUS_CUSTO_UNIMED,
  STATUS_INVOICE_CUSTO_UNIMED,
  STATUS_INVOICE_CUSTO_UNIMED_FALLBACK,
  STATUS_INVOICE_CUSTO_UNIMED_DESCONHECIDO_COLOR,
  MESES,
  DIAS_SEMANA,
  ORIGEM_PRESTADOR,
  STATUS_ENVIO_PGR,
  STATUS_EPI,
  STATUS_ENTREGA_EPI,
  RISCO_ITEMS,
  STATUS_ITEMS,
}
